import Log from "@/components/log";
import Vue from "vue";
import Component from "vue-class-component";
import { apibase } from "@/components/http/api";
import { env } from "@/env";
const KEY_PEFIX = env.VUE_APP_KEY + ":";

@Component
export default class Jssdk extends Vue {
  protected $wx: any;
  protected $wxReady: boolean = false;

  protected initWx(): Promise<WxJsapiSignature> {
    this.$wxReady = false;
    this.$wx = (window as any).wx;
    const url = this.$store.state.core.wxUrl;
    const key = KEY_PEFIX + ":" + encodeURIComponent(url);
    return new Promise((res, rej) => {
      let result: WxJsapiSignature | null = null;
      try {
        result = JSON.parse(
          sessionStorage.getItem(key) as string
        ) as WxJsapiSignature;
        if (result && result.timestamp) {
          if (result.timestamp + 7200 <= new Date().getTime()) {
            result = null;
          }
        }
      } catch (error) {
        Log.error(error);
      }
      if (result) {
        this.ready(result);
        res(result);
      } else {
        apibase
          .post("/weixinmp/jsapi", null, {
            params: { url },
          })
          .then((response) => {
            result = response.data as WxJsapiSignature;
            sessionStorage.setItem(key, JSON.stringify(result));
            this.ready(result);
            res(result);
          })
          .catch((err) => {
            this.$toast({ message: "微信JSSDK签名出错" });
            rej(err);
          });
      }
    });
  }

  private ready(wjs: WxJsapiSignature) {
    wjs.debug = process.env.NODE_ENV === "development";
    this.$wx.ready(() => {
      this.$wxReady = true;
    });
  }
}

export interface WxJsapiSignature {
  appId: string;
  nonceStr: string;
  timestamp: number;
  url?: string;
  signature: string;
  debug?: boolean;
}
